import { Button, Upload, message } from "antd";
import { FaFileImport } from "react-icons/fa";
import { useState } from "react";
import { ProductsService } from "../../services/products.service";

interface ImportButtonProps {
  onSuccess: () => void;
}

const ImportButton = ({ onSuccess }: ImportButtonProps) => {
  const [loading, setLoading] = useState(false);

  const handleImport = async (file: File) => {
    setLoading(true);
    try {
      const response = await ProductsService.importExcel(file);
      if (response.status === 200 || response.status === 201) {
        message.success(
          response.data?.message || "Excel faylı uğurla import edildi!"
        );
        onSuccess();
      } else {
        message.error(
          response.errorMessage || "Excel importu zamanı xəta baş verdi!"
        );
      }
    } catch (error) {
      console.error("Import error:", error);
      message.error("Excel importu zamanı naməlum xəta baş verdi!");
    } finally {
      setLoading(false);
    }
    return false; // Prevent default upload behavior
  };

  return (
    <Upload
      accept=".xlsx, .xls, .csv"
      showUploadList={false}
      beforeUpload={handleImport}
      disabled={loading}
    >
      <Button
        type="primary"
        icon={<FaFileImport size={20} />}
        loading={loading}
        style={{
          backgroundColor: "#3B82F6",
          borderColor: "#3B82F6",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "14px 24px",
          height: "max-content",
        }}
      >
        Import
      </Button>
    </Upload>
  );
};

export default ImportButton;
